import { supabase } from '@/integrations/supabase/client';

/**
 * Check if user has admin or staff role
 * Uses server-side security definer function to prevent privilege escalation
 */
export const isAdminOrStaff = async (userId: string): Promise<boolean> => {
  try {
    // @ts-ignore - RPC function exists but types haven't regenerated yet
    const { data, error } = await supabase.rpc('is_admin_or_staff', {
      _user_id: userId
    });

    if (error) {
      console.error('Error checking admin/staff status:', error);
      return false;
    }

    return !!data;
  } catch (error) {
    console.error('Exception checking admin/staff status:', error);
    return false;
  }
};

/**
 * Check if user has a specific role
 * Uses server-side security definer function to prevent privilege escalation
 */
export const hasRole = async (userId: string, role: 'admin' | 'staff' | 'user'): Promise<boolean> => {
  try {
    // @ts-ignore - RPC function exists but types haven't regenerated yet
    const { data, error } = await supabase.rpc('has_role', {
      _user_id: userId,
      _role: role
    });

    if (error) {
      console.error(`Error checking role ${role}:`, error);
      return false;
    }

    return !!data;
  } catch (error) {
    console.error(`Exception checking role ${role}:`, error);
    return false;
  }
};
